<template>
  <div id="page-detail-candidate">
    <div class="row mr-0 ml-0 pl-0 pr-0">
      <div class="col-lg-12 col-xs-12">
        <div class="mt-3 mb-3 label-bold">
          <span class="text-truncate p-2 f20">VAGA </span>
          <span class="color-purple">{{ job_name }}</span>
        </div>
      </div>
      <div class="col-lg-5 col-xs-12">
        <div
          class="bg-purple color-white"
          :style="{
            borderLeftColor: this.colorBorder,
            borderLeftWidth: '5px',
          }"
          v-show="!show_resume"
        >
          <div class="row color-white direction-box">
            <div class="pr-5">
              <img
                class="thumb-box mt-3 mb-2"
                v-if="avatar != ''"
                :src="avatar"
              />
            </div>
            <div class="content-items mb-3 pt-4 pb-2 text-truncate">
              <p class="mb-0">
                <b>{{ candidate.name }}</b>
              </p>
              <div class="box-icons">
                <span>
                  <a
                    class="f12 color-white"
                    :href="`mailto:${candidate.email}`"
                  >
                    {{ candidate.email }}
                  </a>
                </span>
                <br>
                <span class="f12 color-white">
                  {{ candidate.last_role }} /
                </span>
                <span class="f12 color-white">

                  {{ candidate.last_business }}

                </span>
                <div style="display: flex">
                  <i
                    :class="`${tagName ? 'mt-1' : 'mt-2'} fas f12 mr-2 fa-tags color-purple`"
                  />
                  <div
                    class="color-white center px-1 font-weight-bold"
                    :style="tagColor ? `background-color: ${ tagColor }; text-shadow: 0px 0px 3px black;` : ''"
                  >
                    <span
                      class="f12 pointer"
                      @click="showTagOverview"
                    >
                      {{ tagName != "" ? tagName : "Sem Etiqueta" }}
                    </span>
                  </div>
                </div>
                <div>
                  <i class="fas fa-phone-alt mr-2 color-purple f15"></i>
                  <span class="color-white f12">{{
                    candidate.mobile_phone
                  }}</span>
                </div>
                <div v-if="whatsapp != ''">
                  <i class="fab f15 mr-2 fa-whatsapp color-purple"></i>
                  <a
                    class="color-white f12"
                    :href="`https://wa.me/${whatsapp}?text=%20`"
                    target="_blank"
                  >WHATSAPP</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card-body-noBorder card-light-grey mt-3"
          v-show="!show_resume"
        >
          <BigfiveShow
            v-if="candidate.uid"
            :candidate_uid="candidate.uid"
            :no_next="true"
            :only_graph="true"
            :is_limited="is_limited"
          />
        </div>
        <div
          class="card card-body bg-white mt-3 card-body"
          v-show="!recruiter"
        >
          <p>AVALIE ESSE CANDIDATO(A)</p>
          <AvaliationLike
            v-if="!load_candidate"
            :recruiter="is_recruiter"
            :apply_id="apply.uid"
            :job_id="apply.job_id"
            :like_avaliation="apply.like_avaliation"
            :like_candidate="apply.like_candidate"
            :star_candidate="apply.star_candidate"
            :deslike_candidate="apply.deslike_candidate"
          />
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <div
                @click="show_candidate_data = !show_candidate_data"
                class="row container pointer"
              >
                <p class="pl-3 pt-3">
                  <b v-if="is_limited">DADOS ADICIONAIS</b>
                  <b v-else>MAIS DADOS DO CANDIDATO</b>
                  <font-awesome-icon
                    v-if="show_candidate_data"
                    icon="chevron-up"
                  />
                  <font-awesome-icon
                    v-else
                    icon="chevron-down"
                  />
                </p>
              </div>
              <div
                v-if="show_candidate_data"
                class="container"
                style="background-color: white; border: 1px solid #e6e6e6; color: black"
              >
                <div class="col-lg-12 mt-4">
                  <div class="col-lg-12 col-xs-12">
                    <div class="row mt-1 mb-2">
                      <div class="col-lg-3 col-xs-12">
                        <span>SALARIO</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <span>
                          {{ candidate.remuneration || "Não definido" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-3 col-xs-12">
                        <span>CIDADE NATAL</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <span>
                          {{ candidate.hometown_attributes ? 
                            `${candidate.hometown_attributes.name}/${candidate.hometown_state_attributes.name}`:
                            `Não definido`
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-3 col-xs-12">
                        <span>ETNIA</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <span>
                          {{ getEthnicity(candidate.ethnicity) || "Não definido" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-3 col-xs-12">
                        <span>ORIENTAÇÃO SEXUAL</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <span>
                          {{ getSexualOrientation(candidate.sexual_orientation) || "Não definido" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1 mb-3">
                      <div class="col-lg-3 col-xs-12">
                        <span>PCD</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <span>
                          {{ candidate.is_pcd ? candidate.pcd_description : "Não" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1 mb-1">
                      <div class="col-lg-2 hide col-xs-12">
                        <span>COMPETENCIAS</span>
                      </div>
                      <div class="col-lg-9 col-xs-12">
                        <div
                          class="skill_uni"
                          v-for="skill in skills"
                          :key="skill.id"
                        >
                          {{ skill.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <p class="pl-3 pt-3 mb-3">
                <b v-if="is_limited">STATUS NO PROCESSO</b>
                <b v-else>CLASSIFIQUE ESSE CANDIDATO(A)</b>
              </p>
              <div>
                <select
                  v-model="select_process_id"
                  class="form-control"
                  @change="updateApply()"
                >
                  <option
                    v-for="process in select_process"
                    :key="process.id"
                    :value="process.id"
                  >
                    {{ process.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <p class="pl-3 pt-3">
                <b v-if="is_limited">PORTFÓLIO</b>
                <b v-else>PORTFÓLIO CANDIDATO(A)</b>
              </p>
              <div 
                class="pl-3 pb-3 pt-3 d-flex justify-content-start"
                style="background-color: white; border: 1px solid #e6e6e6; color: black"
              >
                <i
                  class="fas fa-paperclip"
                  style="font-size: 36px"
                ></i>
                <div class="col-lg-10">
                  <div class="text-truncate">
                    <a
                      class="pl-1"
                      :href="candidate.linkedin_url"
                      target="_blank"
                      v-if="candidate.linkedin_url != ''"
                    >
                      {{ this.candidate.linkedin_url }}
                    </a>
                    <span
                      class=""
                      v-if="this.candidate.linkedin_url == null"
                    >
                      NÃO INFORMADO
                    </span>
                  </div>
                  <div class="text-truncate">
                    <a
                      class="pl-1 pt-1"
                      :href="candidate.personal_portfolio"
                      target="_blank"
                      v-if="candidate.personal_portfolio != ''"
                    >
                      {{ candidate.personal_portfolio }}
                    </a>
                    <span
                      class="pl-1"
                      v-if="candidate.personal_portfolio == ''"
                    >
                      NÃO INFORMADO
                    </span>
                  </div>
                  <div class="text-truncate">
                    <a
                      class="pl-1 pt-1"
                      :href="candidate.personal_site"
                      target="_blank"
                      v-if="candidate.personal_site != ''"
                    >
                      {{ this.candidate.personal_site }}
                    </a>
                    <span
                      class="pl-1"
                      v-if="candidate.personal_site == ''"
                    >
                      NÃO INFORMADO
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 ml-0 pl-0 col-xs-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a 
              :class="`nav-link ${ tab === 'answers' ? 'active' : ''}`" 
              aria-current="page"
              @click="setTab('answers')"
            >
              Respostas
            </a>
          </li>
        </ul>
        <div
          v-if="tab === 'answers'"
          style="height: calc(100% - 48px)"
          class="cardy-body-noBorder card-light-grey"
        >
          <div v-show="answers.length > 0">
            <p class="color-grey-primary">
              <b>PERGUNTAS DA ENTREVISTA</b>
            </p>
            <li
              class="li_style_none mt-2 d-flex"
              @click="nextVideo(index)"
              v-for="(answer, index) in answers"
              :key="answer.id"
            >
              <div>
                <a
                  class="color-primary d-flex wrap"
                  style="white-space: normal !important; width: 100%"
                  :class="{
                    active_answer: index == answer_current,
                    first_tab: index == 0,
                  }"
                  :id="`tab${index}_id`"
                  data-toggle="tab"
                  :href="`#tab${index}`"
                  role="tab"
                  :aria-controls="`tab${index}`"
                  aria-selected="true"
                >
                  <div
                    class="d-inline"
                    v-if="[2, 3].includes(answer.question.response_type)"
                  >
                    <RightOrWrongIcons
                      ParentDivClasses="d-inline mr-2"
                      :hide="showPreview(index, answer.question.response_type)"
                      :useSvg="true"
                      :rightIf="rightAnswer(answer, answer.question)"
                      :wrongIf="!rightAnswer(answer, answer.question)"
                    />
                  </div>

                  {{ index + 1 }}.
                  <div
                    class="d-inline"
                    v-if="[2, 3].includes(answer.question.response_type)"
                  ></div>
                  <div
                    class="question_preview d-inline"
                    v-html="truncate(answer.title)"
                  ></div>
                </a>
                <div
                  v-if="answer.question.response_type == 3 || answer.question.response_type == 2"
                  class="mb-3"
                >
                  <span>
                    <b>Resposta: </b>{{ getAnswer(answer) }}
                  </span>
                </div>
                <div
                  class="f14"
                >
                  <div>
                    Tempo total: {{ 
                      getTimeTaken(answer.created_at, answer.updated_at)
                    }}
                  </div>
                  <div>
                    Início: {{ formattedDateTime(answer.created_at) }}
                  </div>
                    <div>
                    Fim: {{ formattedDateTime(answer.updated_at) }}
                  </div>
                </div>
                <hr />
              </div>
            </li>
            <span
              class="f15 d-block to_uppercase"
              v-if="time_taken > 0"
            >O Candidato(a) levou: {{ timeTakenToAnswer }} para responder
              estas perguntas</span>
            <span
              class="f15 d-block to_uppercase"
              v-if="hitsPercentage"
            >
              Percentual de acertos do Candidato(a): {{ hitsPercentage }} %
            </span>
          </div>
          <JobExam
            :questions="questions"
            :answers="answers"
            :candidate="candidate"
            :job_title="job_name"
            :hitsPercentage="hitsPercentage"
          />
          <hr class="bg-purple" />
          <div
            v-if="load"
            class="center bg-black painel_load"
            :class="{ load_video: load }"
          >
            <sweetalert-icon
              icon="loading"
              v-if="load"
            />
          </div>
          <div v-if="!load">
            <div v-if="answers.length > 0">
              <div
                class="pointer color-primary mb-2 label-bold"
                style="white-space: normal !important"
              >
                <div class="d-flex">
                  <span>{{ answer_current + 1 }}.</span>
                  <div
                    style="font-size: 15px !important"
                    v-html="answers[answer_current].title"
                  ></div>
                </div>
              </div>
              <div
                class="mb-2"
                v-if="answerQuestion.response_type == 2"
              >
                <MultipleChoices :answer="answers[answer_current]" />
              </div>
              <div v-if="answerQuestion.response_type == 4">
                <MonetaryType :answer="answers[answer_current]" />
              </div>
              <div
                class="mb-2"
                v-if="answerQuestion.response_type == 3"
              >
                <YesOrNo :answer="answers[answer_current]" />
              </div>
              <div
                class="mb-2"
                v-if="answerQuestion.response_type == 1"
              >
                <p
                  v-if="answers[answer_current].choices"                    
                  class="text-justify"
                >
                  {{ answers[answer_current].choices.text || 'Não respondido.' }}
                </p>
                <p
                  v-else
                  class="text-justify"
                >
                  Não respondido
                </p>
              </div>
              <video
                style="max-height: 500px"
                v-if="answerQuestion.response_type == 0"
                width="100%"
                controls
                playsinlineatributo
                preload="yes"
                controlslist="nodownload"
                id="video_answers"
              >
                <source
                  :src="answers[answer_current].video"
                  type="video/mp4"
                />
              </video>
            </div>
            <div v-else>
              <h4 class="p5 center">Não há respostas</h4>
            </div>
            <div class="mb-2">
              <div class="row">
                <div class="col-lg-5">
                  <button
                    @click="nextVideo(havePreviusAnswer())"
                    :class="{ hide: havePreviusAnswer() === false }"
                    class="btn btn-primary full radius-0"
                  >
                    <i class="fas ml-2 fa-chevron-left"></i>
                    PERGUNTA ANTERIOR
                  </button>
                </div>
                <div class="col-lg-2"></div>
                <div class="col-lg-5">
                  <button
                    @click="nextVideo(haveNextAnswer())"
                    :class="{ hide: haveNextAnswer() === false }"
                    class="btn btn-primary full radius-0"
                  >
                    PRÓXIMA PERGUNTA
                    <i class="fas mr-2 fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <CandidateSkillsRating
              :job_id="this.job_id"
              :candidate_id="this.candidate.id"
              :apply_id="this.apply.id"
              :shortlist_uid="shortlist_uid"
              :recruiter_id="recruiter_id"
            />
            <div
              class="average-skills cardy-body-noBorder p-2 d-flex justify-content-between p-0 m-0"
              v-if="answers.length > 0"
            >
              <span
                class="color-white"
              >
                MÉDIA DA CLASSIFICAÇÃO DE CANDIDATO(A) NESSA PERGUNTA
              </span>
              <StarRating
                active-color="#9472F8"
                :read-only="true"
                :rating="rating_agg"
                v-bind:max-rating="5"
                v-bind:star-size="22"
                v-bind:show-rating="false"
              ></StarRating>
            </div>
            <div
              v-if="answers.length > 0"
              class="inputComment"
            >
              <div>
                <!-- <StarRating
                @rating-selected="ratingSave"
                v-model="rating"
                v-bind:max-rating="5"
                v-bind:star-size="20"
                ></StarRating>-->
                <!-- SE FOR USAR AS ESTRELAS SÓ DESCOMENTAR AI EM CIMA É NOIX -->
              </div>
              <StarRating
                active-color="#9472F8"
                @rating-selected="ratingSave"
                v-model="rating"
                v-bind:max-rating="5"
                v-bind:star-size="22"
                v-bind:show-rating="false"
                class="mt-4 mb-1"
              ></StarRating>
              <hr
                v-if="!hasRightAnswer"
              />
              <div
                v-if="!hasRightAnswer"
                class="row"
              >
                <div class="col-lg-2 col-xs-12">
                  <span class="ml-3 f14 font-weight-bold color-primary">NOTA</span>
                  <input
                    type="number"
                    style="height: 44px"
                    class="form-control mb-2"
                    v-model="score"
                    v-on:keyup.enter="saveAnswerScore"
                    placeholder="NOTA"
                    step="0.5"
                  />
                </div>
                <div class="col-lg-7 col-xs-12">
                  <span class="ml-3 f14 font-weight-bold color-primary">DETALHES DA AVALIAÇÃO</span>
                  <input
                    style="height: 44px"
                    class="form-control mb-2"
                    v-model="description"
                    v-on:keyup.enter="saveAnswerScore"
                    placeholder="DETALHES"
                  />
                </div>
                <div class="col-lg-3 col-xs-12">
                  <button
                    v-on:click="saveAnswerScore"
                    class="bg-purple btn-save-comment"
                    style="height: 42px; margin-top: 25px"
                  >
                    PUBLICAR
                  </button>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-9 col-xs-12">
                  <input
                    style="height: 44px"
                    class="form-control mb-2"
                    v-model="comment"
                    v-on:keyup.enter="saveComments"
                    placeholder="Escreva um comentário"
                  />
                </div>
                <div class="col-lg-3 col-xs-12">
                  <button
                    style="margin: auto"
                    v-on:click="saveComments"
                    class="bg-purple btn-save-comment"
                  >
                    PUBLICAR
                  </button>
                </div>
              </div>
              <hr />
              
            </div>
            <div>
              <div class="row">
                <div class="col-lg-3 col-xs-12">
                  Nº DE TENTATIVAS RESTANTES: {{ 3 - view_evaluation }}
                </div>
                <div class="col-lg-4 col-xs-12">
                  <button
                    v-if="3 - view_evaluation === 0"
                    @click="addEvaluationView()"
                    class="btn btn-primary full radius-0"
                  >
                    <i class="fas mr-2 fa-chevron-left"></i>
                      ADICIONAR MAIS TENTATIVAS
                  </button>
                </div>
              </div>

            </div>
            <div
              class="mt-2 mb-2 all_comments"
              id="all_comments"
              v-if="answers.length > 0"
            >
              <div
                :class="{
                  left: com.manager_name,
                  'bg-primary-light': com.manager_name,
                }"
                class="f12 shadow_bar mt-2 mb-2 mr-4 ml-2 bg-white block_comment"
                v-for="com in comments"
                :key="com.id"
              >
                <div
                  v-if="
                    (com.recruiter_name && recruiter) ||
                    (com.manager_name &&
                      !recruiter &&
                      com.manager_id == manager_id)
                  "
                  @click="deleteComments(com.id)"
                  class="deleteComment bg-primary2 pointer right"
                >
                  <i class="fa fa-times"></i>
                </div>
                <span class="color-primary">
                  <b>{{
                    com.recruiter_name ? com.recruiter_name : com.manager_name
                  }}</b>
                </span>
                <br />
                <span class="conforta">{{ com.description }}</span>
                <div class="text-right">
                  <span class="small-text full color-primary">{{
                    formattedDate(com.created_at)
                  }}</span>
                </div>
              </div>
            </div>

            <div
              v-if="answers.length > 0"
              class="mr-2 inputComment"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 mb-3">
        <div class="row">
          <div class="col-lg-3">
            <button
              @click="nextCandidate(havePrevius(), -1)"
              :class="{ hide: !havePrevius() }"
              class="btn btn-primary full radius-0"
            >
              <i class="fas mr-2 fa-chevron-left"></i>
              CANDIDATO(A) ANTERIOR
            </button>
          </div>
          <div class="col-lg-6"></div>
          <div class="col-lg-3">
            <button
              @click="nextCandidate(haveNext(), +1)"
              :class="{ hide: !haveNext() }"
              class="btn btn-primary full radius-0"
            >
              PRÓXIMO CANDIDATO(A)
              <i class="fas ml-2 fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemTemplate from "components/ItemTemplate.vue";
import moment from "moment";
import BigfiveShow from "@/Bigfives/Show.vue";
import SelectManagers from "components/SelectManagers.vue";
import StarRating from "vue-star-rating";
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import AvaliationLike from "@/ShortlistManagers/AvaliationLike.vue";
import CandidateSkillsRating from "components/CandidateSkillsRating.vue";
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import { required, email } from "vuelidate/lib/validators";
import modal from "vue-js-modal";
import TagList from "../Applies/TagList.vue";
import BtnDonwloadCV from "components/ButtonDonwloadCV.vue";
import MultipleChoices from "../Applies/MultipleChoices.vue";
import MonetaryType from "../Applies/MonetaryType.vue";
import YesOrNo from "../Applies/YesOrNo.vue";
import JobExam from "components/JobExam.vue";
import RightOrWrongIcons from "components/RightOrWrongIcons.vue";
import AppliesExperiencesTab from "@/Recruiters/Applies/ExperiencesTab.vue";
import CurriculumUpload from "components/CurriculumUpload.vue";
import { state } from "store/business.js";

export default {
  components: {
    StarRating,
    AvaliationLike,
    CandidateSkillsRating,
    BigfiveShow,
    Resume,
    SelectManagers,
    BtnDonwloadCV,
    MultipleChoices,
    YesOrNo,
    MonetaryType,
    JobExam,
    RightOrWrongIcons,
    AppliesExperiencesTab,
    CurriculumUpload
  },
  props: [
    "apply_id",
    "candidate_id",
    "job_id",
    "job_name",
    "applies",
    "index",
    "job",
    "user_manager",
    "shortlist_uid",
    "is_recruiter",
    "recruiter_id",
    "manager_id",
    "current",
    "hitsPercentage",
    "account_uid",
    "is_limited",
    "selective_process_id"
  ],
  data: () => ({
    managers: [],
    message: "",
    time_taken: 0,
    jobs: [],
    whatsapp: "",
    job_selected: {},
    load: true,
    candidate: {},
    answers: [],
    questions: [],
    show_resume: false,
    answer_current: 0,
    avatar: "",
    comment: "",
    comments: [],
    import_answer: 0,
    portfolio: "",
    rating: 0,
    rating_agg: 0,
    resume: "",
    title_email: "",
    text_email: "",
    index_current: 0,
    apply: {},
    view_evaluation: 0,
    select_process_id: 0,
    select_process: [],
    itemTemplate,
    recruiter_name: "",
    recruiter: true,
    load_share: false,
    load_copy: false,
    load_candidate: true,
    url_share: "",
    colorBorder: "",
    tagName: "",
    tagColor: "",
    visibility: false,
    show_candidate_data: false,
    tab: 'answers',
    password: "",
    confirm_password: "",
    loading_password: "",
    state: state,
    score: null,
    description: null,
    ethnicities: [
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    sexual_orientations: [
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" },
    ],
  }),
  computed: {
    answerQuestion() {
      return this.answers[this.answer_current].question;
    },
    timeTakenToAnswer() {
      let base = "1 minuto";
      return this.time_taken <= 1 ? base : `${this.time_taken} minutos`;
    },
    hasRightAnswer() {
      return this.answers[this.answer_current].question.choices?.rightAnswers?.length > 0;
    }
  },
  methods: {
    rightAnswer(answer, question) {
      if (answer.choices == null) {
        return false;
      }

      if (!answer.choices.marked) {
        answer.choices.marked = [];
      }

      if (question.response_type == 3) {
        return answer.choices.marked.includes(question.choices.correctAnswer);
      }

      let titles = question.choices.rightAnswer.titles;
      let right = false;
      for (let option of answer.choices.marked) {
        right = titles.includes(option);
        if (right) break;
      }
      return right;
    },
    showPreview(index, response_type) {
      let choices = this.answers[index].question.choices;

      if (response_type == 3) {
        return choices.correctAnswer == "any";
      }

      return !choices.rightAnswer.haveOne;
    },
    haveRightAnswer(choices, response_type, index) {
      if (response_type != 2) return;
      let options = choices.options;

      let rightOptions = options.filter((el) => el.rightAnswer);

      this.answers[index].question.choices.rightAnswer = {
        haveOne:
          rightOptions.length > 0 && rightOptions.length != options.length,
        titles: rightOptions.map((option) => option.title),
      };
    },
    setWppNumber(value) {
      if (!value) {
        return "";
      }
      let characters = ["(", ")", "-", " "];
      for (let char of characters) {
        value = value.replaceAll(char, "");
      }
      this.whatsapp = value;
    },
    add_uid(url) {
      return this.account_uid ? `${url}/${this.account_uid}` : url;
    },
    truncate(title) {
      return title.length > 200
        ? title.slice(0, 200).trim().concat("...")
        : title;
    },
    showTagOverview() {
      this.$modal.show(
        TagList,
        {
          apply_id: this.apply_id,
          candidate_id: this.candidate_id,
        },
        {
          width: "30%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    confirmFeedback(feedback, select_process_id) {
      let candidate = {};
      if (this.applies[this.index_current].name) {
        candidate = {
          candidate_id: this.applies[this.index_current].candidate_id,
          name: this.applies[this.index_current].name,
          email: this.applies[this.index_current].email,
          image: this.applies[this.index_current].image,
        };
      } else {
        candidate = {
          candidate_id: this.applies[this.index_current].candidate.id,
          name: this.applies[this.index_current].candidate.name,
          email: this.applies[this.index_current].candidate.email,
          image: this.applies[this.index_current].image,
        };
      }

      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: [candidate],
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: select_process_id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          clickToClose: false,
          // }
        }
      );
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD HH").format("DD/MM/YYYY HH") + "h";
    },
    formattedDateTime(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    },
    getTimeTaken(start, end) {
      const start_date = new Date(start);
      const end_date = new Date(end);

      const time_taken = Math.abs(end_date - start_date);

      return new Date(time_taken).toISOString().substr(11, 8);
    },
    ratingSave() {
      axios
        .post(this.add_uid("/recruiters/ratings"), {
          ratings: {
            score: this.rating,
            answer_id: this.answers[this.answer_current].id,
            apply_id: this.answers[this.answer_current].apply_id,
          },
        })
        .then((response) => {
          if (this.answers.length > 0) {
            this.getRatingAgg(this.answers[this.answer_current].id);
          }
          this.$toast.success("Avaliação salva com sucesso");
        });
    },
    getRatingAgg(answer_id) {
      axios
        .get(this.add_uid(`/recruiters/ratings/${answer_id}`))
        .then((response) => {
          this.rating_agg = 0;
          if (response.data.rating)
            this.rating_agg = parseInt(response.data.rating);
        });
    },
    deleteComments(comment_id) {
      let conf = confirm("Tem certeza que deseja deletar esse comentário?");

      if (!conf) {
        return;
      }
      axios
        .delete(this.add_uid(`/recruiters/comments/${comment_id}`))
        .then((response) => {
          this.loadComments(this.answers[this.answer_current].id);
        });
    },
    haveNext() {
      if (this.applies[this.index_current + 1]) {
        return this.applies[this.index_current + 1];
      }
      return false;
    },
    havePrevius() {
      if (this.applies[this.index_current - 1]) {
        return this.applies[this.index_current - 1];
      }
      return false;
    },
    havePreviusAnswer() {
      if (this.answers[this.answer_current - 1]) {
        return this.answer_current - 1;
      }
      return false;
    },
    haveNextAnswer() {
      if (this.answers[this.answer_current + 1]) {
        return this.answer_current + 1;
      }
      return false;
    },
    nextCandidate(apply, change) {
      if (!apply) return false;

      this.index_current = this.index_current + change;
      if (this.user_manager) {
        this.answer_current = 0;
        this.loadCandidate(apply.uid, apply.candidate_uid);
        return;
      }
      this.loadCandidate(apply.id, apply.candidate_id);
    },
    saveComments() {
      if (this.comment.length <= 3) {
        this.comment = "";
        this.$toast.error("Você precisa digitar um comentário para salvar");
        return;
      }

      axios
        .post(this.add_uid("/recruiters/comments"), {
          comments: {
            description: this.comment,
            answer_id: this.answers[this.answer_current].id,
            recruiter_id: 0,
            shortlist_uid: this.shortlist_uid,
          },
        })
        .then((response) => {
          this.comment = "";
          this.loadComments(this.answers[this.answer_current].id);
        })
    },
    loadComments(answer_id) {
      axios
        .get(this.add_uid(`/recruiters/comments/${answer_id}/desc`))
        .then((response) => {
          if (this.comments.length != response.data.comments.length) {
            this.comments = response.data.comments;
          }
        });
    },
    nextVideo(index) {
      this.rating = 0;
      this.answer_current = index;
      let video = document.getElementById("video_answers");
      this.loadComments(this.answers[this.answer_current].id);
      this.getRatingAgg(this.answers[this.answer_current].id);
      if (video) {
        video.load();
      }
    },
    updateApply() {
      if (!this.recruiter_id) {
        return;
      }
      if (this.select_process_id != this.apply.selective_process_id) {
        this.apply.status = 2;
      }

      axios
        .put(`/recruiters/applies/${this.apply.id}`, {
          applies: {
            selective_process_id: this.select_process_id,
            status: this.apply.status,
          },
          feedback: {
            selective_process_id: this.select_process_id,
            job_id: this.job_id,
          },
        })
        .then((response) => {
          if (response.data.feedback) {
            this.confirmFeedback(
              response.data.feedback,
              this.select_process_id
            );
            return;
          }

          if (response.data.applies.status == 2) {
            this.$toast.success("Processo seletivo atualizado com sucesso");
          }
        })
        .catch((error) => {
          this.$toast.error("Erro ao atualizar processo seletivo");
        });
    },
    loadCandidate(apply_id, candidate_id) {
      let url = `/shortlist_managers/${this.job_id}/${apply_id}/${candidate_id}`;
      if (!this.user_manager) {
        url = `/recruiters/jobs/${this.job_id}/applies/${apply_id}/${candidate_id}`;
      }

      url = this.add_uid(url);
      this.load_candidate = true;
      axios.get(url).then((response) => {
        this.answers = response.data.answers.filter((answer) => {
          return answer.question.selective_process_id == this.selective_process_id;
        });
        this.time_taken = response.data.time_taken;
        this.candidate = response.data.candidate;
        this.resume = response.data.resume;
        this.avatar = response.data.avatar || "/images/avatar.png";
        if (this.answers[this.answer_current]) {
          this.score = this.answers[this.answer_current].score;
          this.description = this.answers[this.answer_current].description;
        }

        this.answers.map((answer, index) =>
          this.haveRightAnswer(
            answer.question.choices,
            answer.question.response_type,
            index
          )
        );
        this.setWppNumber(this.candidate.mobile_phone);

        this.portfolio = response.data.portfolio_istrue.mandatory_portfolio;
        this.load = false;
        this.apply = response.data.apply;

        this.select_process_id = response.data.apply.selective_process_id;

        this.select_process = response.data.select_process;
        this.recruiter_name = response.data.recruiter_name;

        if (this.apply.tag_apply != null) {
          this.colorBorder = this.apply.tag_apply.tag.color;
          this.tagName = this.apply.tag_apply.tag.name;
          this.tagColor = this.apply.tag_apply?.tag?.color;
        }

        if (this.answers.length > 0) {
          this.loadComments(this.answers[this.answer_current].id);
          this.getRatingAgg(this.answers[this.answer_current].id);
          this.nextVideo(0);
        }

        this.view_evaluation = response.data.candidate.view_evaluation;

        this.job_selected = {};
        if (this.apply.status == 0) {
          this.apply.status = 1;
          this.updateApply();
        }
        this.load_candidate = false;

        if (this.current !== undefined) {
          for (let i = 0; i < this.answers.length; i++) {
            if (this.answers[i].id == this.current) {
              this.answer_current = i;
              this.nextVideo(i);
            }
          }
        }
      });
    },
    loadQuestions(job_id) {
      if (this.is_recruiter) {
        axios.get(`/recruiters/questions/${this.job_id}`).then((response) => {
          this.questions = response.data.questions;
        });
      }
    },
    getEthnicity(ethnicity_id) {
      const ethnicity = this.ethnicities.find((ethnicity) => ethnicity.id === ethnicity_id);
      return ethnicity?.name || "Não definido"
    },
    getSexualOrientation(sexual_orientation_id) {
      const sexual_orientation = this.sexual_orientations.find(
        (sexual_orientation) => sexual_orientation.id === sexual_orientation_id
      )
      return sexual_orientation?.name || 'Não definido'
    },
    addEvaluationView() {
      axios.put(`/recruiters/talent_banks/${this.candidate_id}/candidate/edit`, {
        candidates: {
          view_evaluation: 0,
        },
      }).then(() => {
        this.$toast.success("Foi concedida mais uma tentativa a esse(a) candidato(a)");
        this.view_evaluation = 0;
      })
    },
    setTab(tab) {
      this.tab = tab;
    },
    getAnswer(answer) {
      if (answer.question.response_type == 3) {
        return answer.choices.marked == 'yes' ? 'Sim' : 'Não';
      }
      if (answer.question.response_type == 2) {
        return answer.choices.marked.join(', ');
      }
    },
    setExtraOptions() {
      if (this.state.extra_options) {
        this.state.extra_options?.ethnicity?.length > 0 ?  
          this.ethnicities = this.state.extra_options?.ethnicity?.map((ethnicity, index) => {
            return { name: ethnicity, id: index }
          }) 
        : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0 ?  
          this.sexual_orientations = this.state.extra_options?.sexual_orientation?.map((sexual_orientation, index) => {
            return { name: sexual_orientation, id: index }
          })
        : this.sexual_orientations;
      }
    },
    saveAnswerScore() {
      if (this.score < 0 || this.score > 10 ) {
        this.$toast.error("Escolha um valor entre 1 e 10");
        return;
      }

      axios.put(
        `/recruiters/answers/${this.answers[this.answer_current].id}`,{
          answer: {
            score: this.score,
            description: this.description,
          }
        }
      )
      .then(() => {
        this.$toast.success("Avaliação salva com sucesso");
        if (this.answers[this.answer_current]) {
          this.answers[this.answer_current].score = this.score;
          this.answers[this.answer_current].description = this.description;
        }
      })
    },
  },
  watch: {
    "state.extra_options"() {
      this.setExtraOptions();
    },
    answer_current() {
      if (this.answers[this.answer_current]) {
        this.score = this.answers[this.answer_current].score;
        this.description = this.answers[this.answer_current].description;
        return;
      }
      this.score = null;
      this.description =  null;
    }
  },
  mounted() {
    this.index_current = this.index;
    this.loadCandidate(this.apply_id, this.candidate_id);
    this.loadQuestions();

    eventBus.$emit("setDraggable", false);

    eventBus.$on("setTag", (color, name) => {
      this.colorBorder = color;
      this.tagName = name;
    });

    if (this.is_recruiter === false || this.is_recruiter === true) {
      this.recruiter = this.is_recruiter;
    }
    if (this.answers.length != 0) {
      if (this.answers[this.answer_current].id) {
        this.loadComments(this.answers[this.answer_current].id);
      }
    }

    this.setExtraOptions();
  },
};
</script>

<style>
  .nav-link {
    background-color: transparent !important;
    cursor: pointer;
  }
  .nav-link.active {
    background-color: #e6e6e6 !important;
  }

</style>
